import {FEATURE_SECTION_ORDER, useVehicleFeaturesV2} from '@dms/shared';

import {sortByAsciiNumberLast} from 'shared/web';

export type FeatureSection = ReturnType<
  typeof useVehicleFeaturesV2
>['categorizedFeaturesTree'][number];

const getSectionIndex = (section: FeatureSection) => {
  const index = FEATURE_SECTION_ORDER.indexOf(section.key);
  return index === -1 ? FEATURE_SECTION_ORDER.length : index;
};

/**
 * Drops empty sections, sorts features alphabetically and sections by `FEATURE_SECTION_ORDER`.
 */
export const getOrderedFeatureSections = (sections: FeatureSection[]): FeatureSection[] =>
  sections
    .filter((section) => section.features.length > 0)
    .map((section) => ({
      ...section,
      features: section.features.toSorted((a, b) =>
        sortByAsciiNumberLast(a.labels[0]?.label ?? a.const_key, b.labels[0]?.label ?? b.const_key)
      ),
    }))
    .toSorted((a, b) => getSectionIndex(a) - getSectionIndex(b));
